import { render, staticRenderFns } from "./carmonthchargeruleNewForm.vue?vue&type=template&id=83f23db6&scoped=true&"
import script from "./carmonthchargeruleNewForm.vue?vue&type=script&lang=js&"
export * from "./carmonthchargeruleNewForm.vue?vue&type=script&lang=js&"
import style0 from "./carmonthchargeruleNewForm.vue?vue&type=style&index=0&id=83f23db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f23db6",
  null
  
)

export default component.exports